var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"border-left border-right content",attrs:{"lg":"6","md":"9","sm":"9","cols":"12"}},[(_vm.spinner)?_c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"variant":"secondary"}})],1):_vm._e(),_c('page-user-public')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }